export default {
  isGcsOrMetGaUser: (model) => {
    return (
      model.userType_ML.value &&
      (model.userType_ML.value.code === "gcssales_ml" ||
        model.userType_ML.value.code === "gcsservice_ml" ||
        model.userType_ML.value.code === "metga_ml")
    );
  },
    isOnlyGCSUser: (model) => {
    return (
      model.userType_ML.value &&
      (model.userType_ML.value.code === "gcssales_ml" ||
        model.userType_ML.value.code === "gcsservice_ml")
    );
  },
};

;
